import { useSecrets } from "@/context/SecretsContext";
import { SecretOverlay } from "@/components/secrets/SecretOverlay";
import { PersonnelFile } from "@/components/secrets/PersonnelFile";
import { RedactedText } from "@/components/redaction/RedactedText";
import { BOOK_SIX } from "@/data/secrets";

const TRANSMISSION = {
  eyebrow: "Unregistered transmission \u00b7 origin unresolved",
  title: "6.13",
  footer: "MANUAL TRANSMIT LINE \u00b7 STILL OPEN",
  lines: [
    "You typed the interval.",
    "Somebody on Aster Reach reached for the same six seconds, forty meters beneath the east transit spine, and no record of her doing it survives.",
    "She tore the panelling off an obsolete optical trunk, broke the safety seal and drove the lever down anyway. That is the only reason anyone knows the colony died at all.",
    "Systems fail. Not all of them at once."
  ]
};

const DEDICATION = {
  eyebrow: "Book Six \u00b7 dedication page \u00b7 partially recovered",
  title: "The sixth dedication",
  footer:
    "THE OTHER FIVE READ: GO BACK \u00b7 CARRY THE WEIGHT \u00b7 REMAIN THEMSELVES \u00b7 REMAIN THEIR OWN \u00b7 COME HOME"
};

/** Renders whichever anomaly overlay is currently open. */
export const AnomalyOverlayHost = () => {
  const { overlay, closeOverlay } = useSecrets();
  const kind = overlay?.kind;

  if (kind === "transmission") {
    return (
      <SecretOverlay
        open
        onClose={closeOverlay}
        eyebrow={TRANSMISSION.eyebrow}
        title={TRANSMISSION.title}
        footer={TRANSMISSION.footer}
        testId="anomaly-transmission"
      >
        {TRANSMISSION.lines.map((line, i) => (
          <p
            key={i}
            className="text-[15px] leading-relaxed text-[hsl(210_14%_84%)]"
          >
            {line}
          </p>
        ))}
      </SecretOverlay>
    );
  }

  if (kind === "dedication") {
    return (
      <SecretOverlay
        open
        onClose={closeOverlay}
        eyebrow={DEDICATION.eyebrow}
        title={DEDICATION.title}
        footer={DEDICATION.footer}
        testId="anomaly-dedication"
      >
        <p className="text-xl italic leading-relaxed text-[hsl(32_70%_72%)]">
          <RedactedText text={BOOK_SIX.dedication} />
        </p>
        <p className="text-sm leading-relaxed text-[hsl(210_12%_76%)]">
          {BOOK_SIX.dedicationNote}
        </p>
      </SecretOverlay>
    );
  }

  if (kind === "personnel") {
    return (
      <SecretOverlay
        open
        onClose={closeOverlay}
        eyebrow="Personnel file · unsealed"
        title="Subject identified"
        footer="THE AUTHOR HID INSIDE HIS OWN MANUSCRIPT. YOU FOUND HIM."
        testId="anomaly-personnel"
      >
        <PersonnelFile variant="dark" />
      </SecretOverlay>
    );
  }

  return null;
};
